import {clsx} from 'clsx'

import {BrandPageContent} from '../../../brand/components/BrandPage'
import Hero from './components/sections/Hero/Hero'
import Features from './components/sections/Features/Features'
import CtaBanner from './components/sections/CtaBanner/CtaBanner'
import Faq from './components/sections/Faq/Faq'
import {securityPlansPage} from './content'

import SecurityStyles from './../_styles/shared.module.css'
import GlobalStyles from './styles/global.module.css'

export default function SecurityPlansIndex() {
  return (
    <BrandPageContent
      definition={securityPlansPage}
      className={clsx(SecurityStyles.root, SecurityStyles.fontSmoothing, GlobalStyles.root)}
    >
      {({faq, hero, pricing, subnav}) => (
        <>
          {hero?.component && hero.pricingOptions ? (
            <Hero subnav={subnav} contentfulContent={hero.component} pricingOptions={hero.pricingOptions} />
          ) : null}

          {pricing?.pricingTable.length ? <Features categories={pricing.pricingTable} /> : null}

          {pricing?.ctaBanner ? <CtaBanner contentfulContent={pricing.ctaBanner} /> : null}

          {faq ? <Faq contentfulContent={faq} /> : null}
        </>
      )}
    </BrandPageContent>
  )
}
